export const it = {
  common: {
    app: {
      ownerName: "Riccardo",
      logoAlt: "Logo BlackFlag",
      homeLinkAriaLabel: "Vai alla home page",
    },
    navigation: {
      ariaLabel: "Navigazione principale",
      home: "Home",
      projects: "Progetti",
      skills: "Competenze",
      about: "Chi sono",
      playground: "Playground",
      contact: "Contatti",
      openMenu: "Apri il menu di navigazione",
      switchThemeToLight: "Passa al tema chiaro",
      switchThemeToDark: "Passa al tema scuro",
      switchLanguage: "Cambia lingua",
    },
    languages: {
      it: "IT",
      en: "EN",
      fr: "FR",
    },
    profile: {
      name: "Riccardo Licciardi",
      role: "Frontend Engineer | Aspirante Fullstack | AI & Real-Time Systems Enthusiast",
      location: "Venezia (VE), Italia",
      bio: "Frontend Engineer con 5 anni di esperienza nello sviluppo di applicazioni web scalabili per piattaforme ad alto traffico, con volumi fino a 800.000 utenti. Specializzato in React e Angular, Riccardo interviene su architetture complesse con refactoring strutturali orientati a performance, scalabilita' e manutenibilita'. Sta evolvendo verso un profilo fullstack, integrando competenze avanzate in AI, LLM, STT/TTS e sistemi di comunicazione real-time.",
      links: {
        linkedin: "https://www.linkedin.com/in/riccardolicciardi/",
        github: "https://github.com/riccardo-licciardi",
        presentationVideo: "https://www.youtube.com/shorts/W2_ucKXSwro",
      },
      contacts: {
        phone: "+39 347 51 42 807",
        email: "riccardo.licciardi@gmail.com",
      },
    },
    aboutPage: {
      eyebrow: "Profilo",
      title:
        "Una base solida tra disciplina, ingegneria del software e sistemi scalabili",
      imageAlt: "Ritratto di Riccardo Licciardi",
      presentation: {
        eyebrow: "Video presentazione",
        title: "Una presentazione rapida del mio profilo in 2 minuti",
        frameTitle: "Video presentazione di Riccardo Licciardi",
      },
      paragraphs: {
        first:
          "Riccardo Licciardi e' un Frontend Engineer con 5 anni di esperienza nello sviluppo di applicazioni web scalabili per piattaforme ad alto traffico. Lavora con React e Angular su prodotti complessi, dove refactoring strutturali, qualita' del codice e manutenibilita' sono leve concrete per migliorare performance e sostenibilita' nel tempo.",
        second:
          "Negli ultimi anni ha consolidato un approccio orientato all'architettura modulare, alla chiarezza dei workflow e all'evoluzione progressiva di codebase articolate. Oggi sta espandendo il proprio profilo verso il fullstack, integrando Node.js, Python, FastAPI e competenze in AI, LLM, STT/TTS e comunicazione real-time.",
        third:
          "Prima del software ha prestato servizio nell'Esercito Italiano con il 4° Reggimento Paracadutisti Alpini, all'interno delle Forze per Operazioni Speciali. La disciplina, la responsabilita' e la determinazione maturate in quel percorso sono diventate parte del suo modo di affrontare progetti, team e decisioni tecniche.",
      },
    },
    techStack: {
      sections: {
        frontend: {
          title: "Core Frontend",
          frameworks: ["React", "Angular"],
          languages: ["TypeScript", "JavaScript (ES6+)"],
          stateAndBuild: ["Redux Toolkit", "Vite"],
          uiLibraries: [
            "Material UI (MUI)",
            "Kendo UI",
            "Tailwind CSS",
            "Lucide-react",
          ],
        },
        backendAi: {
          title: "Backend & AI",
          backend: ["Node.js", "Python", "FastAPI"],
          aiIntegration: [
            "OpenAI API",
            "Gemini API",
            "Speech-to-Text (STT)",
            "Text-to-Speech (TTS)",
          ],
          realTime: ["WebSockets", "SIP", "Asterisk"],
        },
        infrastructure: {
          title: "Infrastructure & Tools",
          databases: ["PostgreSQL", "SQL Server"],
          devops: ["Docker", "CI/CD", "Git", "GitLab", "GitHub"],
          methodologies: ["Agile (Scrum)", "Sprint Planning", "Code Review"],
          design: ["Figma", "Swagger"],
        },
      },
    },
    homeSkillsCard: {
      tabs: {
        frontend: "Frontend",
        backend: "Backend",
        goals: "Obiettivi futuri",
      },
      sections: {
        frontend: {
          eyebrow: "Ingegneria Frontend",
          title: "Architetture modulari per prodotti ad alta scala",
          description:
            "Progetta front-end scalabili organizzando basi codice complesse tramite architetture modulari e refactoring che aumentano performance, manutenibilita' e velocita' di evoluzione del prodotto.",
        },
        backend: {
          eyebrow: "Backend, AI e Real-Time",
          title: "API affidabili e sistemi voice AI in tempo reale",
          description:
            "In fase di espansione verso il backend e l'intelligenza artificiale, sta consolidando le competenze necessarie per orchestrare processi aziendali complessi, pipeline vocali in tempo reale e flussi di dati strutturati per l'automazione.",
        },
        goals: {
          eyebrow: "Evoluzione Fullstack",
          title: "System design, cloud e visione end-to-end",
          description:
            "L'obiettivo e' consolidare un profilo fullstack capace di progettare sistemi end-to-end, con maggiore profondita' su system design, cloud, integrazione AI e workflow affidabili per piattaforme complesse e ad alto volume.",
        },
      },
      skills: {
        react: "React",
        typescript: "TypeScript",
        materialUi: "Material UI",
        htmlCss: "Angular",
        nodejs: "Node.js",
        express: "FastAPI",
        restApi: "OpenAI / Gemini API",
        sqlDataModeling: "PostgreSQL / SQL Server",
        java: "Python",
        csharp: "WebSockets",
        cloudDevops: "Docker / CI/CD / Git",
        systemDesign: "Sistemi real-time e AI Voice",
      },
      introducing: {
        title: "Riccardo Licciardi",
        description:
          "Riccardo Licciardi e' un Frontend Engineer con 5 anni di esperienza nello sviluppo di applicazioni web scalabili per piattaforme ad alto traffico, con volumi fino a 800.000 utenti. Specializzato in React e Angular, lavora su architetture complesse con un approccio orientato a refactoring, performance e manutenibilita'. Sta evolvendo verso un profilo fullstack, integrando competenze in AI, LLM, STT/TTS e sistemi di comunicazione real-time.",
      },
      buttons: {
        viewProjects: "Scopri i progetti",
        contactMe: "Contattami",
        details: "Dettagli",
      },
    },
    skillsPage: {
      eyebrow: "Competenze",
      title: "Stack operativo, strumenti chiave e traiettoria di crescita",
      description:
        "Una panoramica più ampia delle tecnologie con cui costruisco interfacce, integrazioni backend e workflow evolutivi. Ogni blocco resta sintetico: focus pratico, contesto d'uso e stack associato.",
      searchPlaceholder: "Cerca tra React, FastAPI, Docker, PostgreSQL...",
      searchButton: "Cerca",
      searchAriaLabel: "Cerca tecnologie",
      emptyStateTitle: "Nessuna tecnologia trovata",
      emptyStateDescription:
        "Prova con un tag diverso oppure svuota la ricerca per vedere tutte le competenze.",
      sections: {
        frontend: {
          eyebrow: "Frontend",
          title: "UI modulari e prodotti ad alta manutenzione",
          description:
            "Tecnologie e librerie usate per costruire interfacce scalabili, rifinire componenti e governare codebase complesse.",
        },
        backend: {
          eyebrow: "Backend & AI",
          title: "Servizi, integrazioni e pipeline real-time",
          description:
            "Stack usato per API, orchestrazione di processi e workflow conversazionali o data-driven.",
        },
        goals: {
          eyebrow: "Obiettivi futuri",
          title: "Crescita fullstack e profondità architetturale",
          description:
            "Aree che sto consolidando per aumentare autonomia end-to-end, qualità sistemica e solidità progettuale.",
        },
      },
      tags: {
        react: "React",
        reduxToolkit: "Redux Toolkit",
        vite: "Vite",
        typescript: "TypeScript",
        angular: "Angular",
        kendoUi: "Kendo UI",
        restApi: "REST APIs",
        javascript: "JavaScript",
        materialUi: "Material UI",
        tailwindCss: "Tailwind CSS",
        htmlCss: "HTML / CSS",
        figma: "Figma",
        nodejs: "Node.js",
        python: "Python",
        fastapi: "FastAPI",
        openaiApi: "OpenAI API",
        geminiApi: "Gemini API",
        websockets: "WebSockets",
        asterisk: "Asterisk",
        sttTts: "STT / TTS",
        postgresql: "PostgreSQL",
        docker: "Docker",
        cicd: "CI/CD",
        git: "Git",
        cloud: "Cloud",
        systemDesign: "System Design",
        csharp: "C# / .NET",
        sqlServer: "SQL Server",
        architecture: "Architettura modulare",
        observability: "Observability",
        llm: "LLM",
      },
      items: {
        frontend: {
          react: {
            title: "React Ecosystem",
            summary:
              "Interfacce modulari, refactoring e scalabilità per prodotti complessi.",
          },
          angular: {
            title: "Angular Enterprise",
            summary:
              "Piattaforme enterprise, dashboard operative e workflow articolati.",
          },
          typescript: {
            title: "TypeScript First",
            summary:
              "Tipizzazione solida per ridurre regressioni e migliorare la manutenibilità.",
          },
          ui: {
            title: "UI Systems",
            summary:
              "Design system coerenti, componenti riusabili e sviluppo responsive.",
          },
        },
        backend: {
          node: {
            title: "Node.js Services",
            summary:
              "Logiche server e servizi full-stack orientati all'efficienza operativa.",
          },
          python: {
            title: "Python & FastAPI",
            summary:
              "API snelle, orchestrazione processi e integrazioni AI avanzate.",
          },
          realtime: {
            title: "Real-Time Voice Workflows",
            summary:
              "Pipeline conversazionali e automazioni ad eventi per sistemi Voice AI.",
          },
          data: {
            title: "Data & Delivery",
            summary:
              "Persistenza, container e CI/CD per ambienti stabili ed evolutivi.",
          },
        },
        goals: {
          architecture: {
            title: "System Design",
            summary:
              "Analisi di trade-off, modularità e scalabilità di sistemi complessi.",
          },
          cloud: {
            title: "Cloud & DevOps",
            summary:
              "Consolidamento di deployment e pipeline per il rilascio continuo.",
          },
          dotnet: {
            title: "C# / .NET",
            summary:
              "Espansione verso backend enterprise e integrazioni fortemente tipizzate.",
          },
          ai: {
            title: "AI Reliability",
            summary:
              "Ottimizzazione di workflow LLM e STT/TTS con focus su robustezza.",
          },
        },
      },
    },
    homeIntro: {
      chip: "Frontend Engineer",
      title: "Riccardo Licciardi",
      description:
        "Frontend Engineer orientato a scalabilita', manutenibilita' e qualita' architetturale. Progetta prodotti web solidi e sta evolvendo verso un profilo fullstack con focus su AI e sistemi real-time.",
      rotatingSentences: {
        first: "Architetture modulari per prodotti complessi",
        second: "Refactoring, più performance e manutenibilita'",
        third: "Workflow AI e sistemi real-time, miglior esecuzione",
      },
    },
    homeContact: {
      eyebrow: "Contatti",
      title: "Parliamo di prodotto, architettura o nuove collaborazioni",
      description:
        "Se stai costruendo una piattaforma web, un'interfaccia complessa o un workflow real-time con integrazione AI, puoi contattarmi direttamente qui. Preferisco conversazioni chiare, rapide e orientate all'esecuzione.",
      items: {
        email: {
          label: "Email",
          helper: "Tocca per copiare l'indirizzo email",
        },
        phone: {
          label: "Telefono",
          helper: "Tocca per copiare il numero di telefono",
        },
      },
      copied: "Copiato negli appunti",
      cta: "Vai alla pagina contatti",
    },
    contactPage: {
      eyebrow: "Contatti",
      title: "Contatti diretti e messaggio rapido",
      description:
        "Se vuoi confrontarti su un progetto, una collaborazione o un'idea da trasformare in prodotto, qui trovi i miei riferimenti diretti e un modo semplice per aprire subito una mail gia compilata.",
      copied: "Copiato negli appunti",
      open: "Apri",
      items: {
        email: {
          label: "Email",
          helper: "Tocca per copiare l'indirizzo email",
        },
        phone: {
          label: "Telefono",
          helper: "Tocca per copiare il numero di telefono",
        },
      },
      form: {
        eyebrow: "Messaggio",
        title: "Invia un messaggio diretto",
        description:
          "Questo form apre il tuo client email con i dati gia compilati, cosi puoi contattarmi rapidamente senza backend dedicato.",
        fields: {
          name: "Nome",
          email: "Email",
          message: "Messaggio",
        },
        submit: "Apri bozza email",
        reset: "Reset",
        subjectPrefix: "Contatto portfolio da",
        fallbackContactName: "un nuovo contatto",
        bodyLabels: {
          name: "Nome",
          email: "Email",
        },
      },
    },
    homeProjects: {
      eyebrow: "Progetti selezionati",
      title: "Tre anteprime rapide del mio lavoro",
      description:
        "Una selezione compatta di progetti che mostrano refactoring architetturale, sistemi AI voice real-time e strumenti full-stack orientati ai dati.",
      previewLabel: "Anteprima",
      viewAll: "Vedi tutti",
      items: [
        {
          title: "Piattaforma di Voto Digitale (Opinio)",
          category: "Frontend ad alta scala",
          description:
            "Refactoring completo di una piattaforma elettorale per oltre 800.000 utenti.",
          tags: ["React", "Redux Toolkit", "Vite"],
        },
        {
          title: "AI Voice PBX",
          category: "Voice AI real-time",
          description:
            "Centralino intelligente multi-tenant con pipeline STT, LLM e TTS.",
          tags: ["Python", "FastAPI", "Asterisk"],
        },
        {
          title: "Restaurant Expense Analyzer",
          category: "Full-stack analytics",
          description:
            "Analisi automatizzata di fatture PDF con AI e dashboard interattive.",
          tags: ["React", "Node.js", "TypeScript"],
        },
        {
          title: "Piattaforma Retail DINAMO",
          category: "Retail microservizi",
          description:
            "Piattaforma retail per cassa, magazzino e workflow operativi su larga scala.",
          tags: ["Angular", "Kendo UI", "REST APIs"],
        },
        {
          title: "Piattaforma Formazione Professionale (CNAPPC)",
          category: "Dashboard multi-ruolo",
          description:
            "Gestione crediti CFP e flussi di acquisto per oltre 100.000 professionisti.",
          tags: ["React", "TypeScript", "REST APIs"],
        },
        {
          title: "Sistema Gestione Officine & Mappe Realtime",
          category: "Mappe e tracking realtime",
          description:
            "Tracciamento lavori via QR code e visualizzazione geospaziale realtime.",
          tags: ["Node.js", "PostgreSQL", "Leaflet"],
        },
      ],
    },
    projects: {
      eyebrow: "Esperienze e progetti core",
      title: "Piattaforme scalabili, AI voice e workflow data-driven",
      description:
        "Una selezione di esperienze e progetti che coprono refactoring architetturale, prodotti ad alto traffico, piattaforme full-stack e sistemi real-time integrati con AI.",
      previewLabel: "Progetto",
      openDetails: "Apri dettagli",
      close: "Chiudi",
      stackLabel: "Stack",
      detailsLabel: "Dettagli",
      items: [
        {
          title: "Piattaforma di Voto Digitale (Opinio)",
          role: "Frontend Engineer",
          category: "Frontend ad alta scala",
          description:
            "Riccardo ha guidato la transizione da una base legacy obsoleta a una piattaforma web moderna e scalabile, ricostruendo l'architettura frontend con un approccio modulare in React per recuperare ritardi, migliorare la manutenibilita' e sostenere processi elettorali sicuri per oltre 800.000 utenti.",
          details: [
            "Transizione critica da un'architettura legacy obsoleta a una piattaforma web moderna e scalabile.",
            "Ricostruzione completa del frontend con approccio modulare e best practice React.",
            "Supporto a processi elettorali sicuri per oltre 800.000 utenti.",
          ],
          stack: [
            "React",
            "Redux Toolkit",
            "Vite",
            "Material UI",
            "Blockchain",
          ],
        },
        {
          title: "AI Voice PBX (Centralino Intelligente)",
          role: "Fullstack / AI Engineer",
          category: "Voice AI real-time",
          description:
            "Riccardo ha progettato una piattaforma voice AI multi-tenant capace di gestire conversazioni telefoniche real-time, estrarre dati strutturati tramite custom tools e attivare workflow aziendali automatici, come la generazione e l'invio di lead via email.",
          details: [
            "Piattaforma scalabile di Voice AI per automazione dell'accoglienza telefonica e raccolta dati.",
            "Pipeline real-time STT → LLM → TTS con estrazione di informazioni strutturate tramite custom tools.",
            "Architettura multi-tenant pensata per workflow aziendali e diversi settori verticali.",
          ],
          stack: [
            "Python",
            "FastAPI",
            "Asterisk",
            "Gemini STS",
            "OpenAI API",
            "Docker",
            "PostgreSQL",
          ],
        },
        {
          title: "Restaurant Expense Analyzer",
          role: "Fullstack Developer",
          category: "Full-stack analytics",
          description:
            "Riccardo ha sviluppato uno strumento full-stack per l'analisi automatizzata di fatture PDF non strutturate, combinando estrazione dati con AI, dashboard interattive e workflow di export per supportare decisioni contabili su dataset ad alta densita'.",
          details: [
            "Caricamento massivo di fatture PDF con estrazione automatica di dati granulari tramite AI.",
            "Dashboard interattive per aggregare costi e visualizzare la distribuzione della spesa.",
            "Workflow di export pensati per supportare processi contabili e decisionali.",
          ],
          stack: [
            "React",
            "Node.js",
            "TypeScript",
            "Tailwind CSS",
            "Recharts",
            "LLM Integration",
          ],
        },
        {
          title: "Piattaforma Retail DINAMO",
          role: "Frontend Engineer",
          category: "Retail microservizi",
          description:
            "Riccardo ha contribuito allo sviluppo di una piattaforma retail a microservizi per cassa e magazzino, implementando funzionalita' operative, integrando endpoint complessi e migliorando l'efficienza di componenti legacy in workflow commerciali ad alta operativita'.",
          details: [
            "Sviluppo di funzionalita' per operazioni di cassa e gestione magazzino in architettura a microservizi.",
            "Integrazione di endpoint complessi per sistemi di vendita e logistica.",
            "Miglioramento dell'efficienza di componenti legacy in workflow retail ad alta operativita'.",
          ],
          stack: ["Angular", "Kendo UI", "REST APIs"],
        },
        {
          title: "Piattaforma Formazione Professionale (CNAPPC)",
          role: "Frontend Engineer",
          category: "Dashboard multi-ruolo",
          description:
            "Riccardo ha progettato e realizzato funzionalita' chiave per la gestione dei crediti CFP e dashboard multi-ruolo, costruendo da zero flussi di acquisto e monitoraggio per una piattaforma dedicata a oltre 100.000 professionisti.",
          details: [
            "Progettazione da zero di feature per il monitoraggio dei crediti CFP.",
            "Realizzazione di dashboard multi-ruolo per Ordini, Fornitori e Professionisti.",
            "Implementazione di flussi di acquisto e monitoraggio per oltre 100.000 iscritti.",
          ],
          stack: ["React", "TypeScript", "REST APIs"],
        },
        {
          title: "Sistema Gestione Officine & Mappe Realtime",
          role: "Fullstack Developer",
          category: "Mappe e tracking realtime",
          description:
            "Riccardo ha sviluppato una piattaforma per il tracciamento lavori via QR code e una mappa geospaziale interattiva per la rete di teleriscaldamento di Asiago, combinando logiche di back-end, dati territoriali e visualizzazione real-time delle attivita'.",
          details: [
            "Piattaforma per il tracciamento delle attivita' tramite QR code.",
            "Mappa geospaziale interattiva per la gestione della rete di teleriscaldamento di Asiago.",
            "Integrazione tra logiche back-end, dati territoriali e visualizzazione realtime.",
          ],
          stack: ["Node.js", "PostgreSQL", "Leaflet", "JavaScript"],
        },
      ],
    },
    testimonials: {
      eyebrow: "Testimonianze",
      title: "Feedback da contesti progettuali complessi",
      description:
        "Una raccolta di feedback che evidenzia affidabilita', visione progettuale e capacita' di trasformare esigenze complesse in soluzioni tecniche solide e utili al business.",
      items: [
        {
          author: "Michele Albertini",
          role: "CEO Didanet",
          quote:
            "Riccardo si e' distinto per una spiccata iniziativa personale e per una solida visione progettuale. Ha sempre mostrato disponibilita' a impegnarsi oltre l'orario ordinario quando necessario, mantenendo elevati standard qualitativi. E' in grado di interagire direttamente con il cliente in modo professionale ed efficace, contribuendo attivamente al problem solving anche in contesti complessi.",
        },
        {
          author: "V3L Studio",
          role: "Studio di consulenza e sviluppo",
          quote:
            "Collaborare con Riccardo e' diventato un asset strategico per il nostro studio. Ha dimostrato una capacita' straordinaria nel tradurre visioni complesse in architetture solide, gestendo in totale autonomia progetti sfidanti come l'integrazione di sistemi Voice AI e pipeline real-time. La sua proattivita' e l'approccio full-stack ci permettono di consegnare soluzioni all'avanguardia con la massima fiducia. Riccardo non e' solo un ottimo sviluppatore, ma un partner tecnico affidabile che porta valore reale a ogni workflow aziendale che tocca.",
        },
        {
          author: "Dott.ssa Elena V.",
          role: "Notaio",
          quote:
            "Per un professionista del mio settore, l'affidabilita' e il rigore sono imprescindibili. Riccardo ha saputo tradurre queste necessita' in un sito web istituzionale che trasmette autorevolezza e chiarezza. La sua capacita' di ascolto e la precisione tecnica nel gestire la transizione digitale del mio studio sono state impeccabili. Ha curato ogni dettaglio, dalla sicurezza alla facilita' di navigazione, superando le mie aspettative.",
        },
        {
          author: "Dott. Valerio Noto",
          role: "Notaio",
          quote:
            "Affidabilita' e rigore sono imprescindibili nel mio settore. Riccardo ha saputo tradurre queste necessita' sia nella creazione del logo che nel sito web istituzionale. La sua precisione tecnica e la cura dei dettagli hanno superato le mie aspettative, comunicando perfettamente l'autorevolezza del mio studio.",
        },
        {
          author: "Bea",
          role: "Guida Spirituale & Mentor",
          quote:
            "Riccardo sta dando vita alla mia visione in un modo che non avrei mai immaginato. Creare un'app dedicata alla meditazione e alla spiritualita' richiede una sensibilita' particolare verso l'esperienza utente; lui e' riuscito a unire la complessita' tecnica con un'interfaccia che trasmette pace e serenita'. E' uno sviluppatore che non si limita a scrivere codice, ma entra in empatia con l'anima del progetto.",
        },
      ],
    },
  },
} as const;
